<template lang="html">
  <div class="dashboard">
    <section class="create">
      <div class="">
        <h3>Create a new draft for the rest of your league</h3><br />
        <draft-card />
      </div>

      <h2 class="or">OR</h2>

      <form class="join" @submit.prevent="join">
        <h3>Join an existing draft setup by your commissioner</h3><br>
        <input
          type="text"
          required
          maxlength="30"
          placeholder="Invite Code"
          v-model="code"
        >

        <button type="submit">Join Draft</button>
      </form>
    </section>

    <section class="existing" v-show="drafts.length">
      <h3>My Drafts</h3>
      <div class="card-layout">
        <div class="card-container" v-for="(draft, i) in drafts" :key="i">
          <draft-card :draft="draft" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import DraftCard from './DraftCard';

export default {
  data() {
    return {
      code: '',
    };
  },

  components: {
    DraftCard,
  },

  computed: {
    ...mapState({
      drafts: ({ draft }) => draft.drafts,
    }),
  },

  methods: {
    join() {
      this.$router.push(`/invite?code=${this.code}`);
    },
  },
};
</script>

  <style lang="scss" rel="stylesheet/scss" scoped>
    .dashboard {
      @include container;
      padding-top: $gp * 2;
      padding-bottom: $gp * 2;
    }

    .create {
      display: flex;
      justify-content: space-between;
      margin-bottom: $gp * 2;

      @media($small) {
        display: block;
      }
    }

    .or {
      display: flex;
      align-items: center;

      @media($medium) {
        margin-left: $gp;
        margin-right: $gp;
      }

      @media($small) {
        margin-bottom: $gp * 2;
        margin-top: $gp * 2;
      }
    }

    .join {
      max-width: px-to-rem(320px);
      margin-bottom: $gp * 2;

      input {
        max-height: px-to-rem(80px);
        line-height: px-to-rem(80px);
        font-size: px-to-rem(42px);
      }
    }

    .card-layout {
      @include cardLayout;
    }
  </style>
